import { format } from "date-fns/format";
import { startOfDay } from "date-fns/startOfDay";

export type ThreadDayGroup<T extends { sentAt: Date }> = {
    dateKey: string;
    date: Date;
    items: T[];
};

export function groupThreadByDay<T extends { sentAt: Date }>(
    items: T[],
): ThreadDayGroup<T>[] {
    const groups: ThreadDayGroup<T>[] = [];

    for (const item of items) {
        const dateKey = format(item.sentAt, "yyyy-MM-dd");
        const last = groups.at(-1);
        if (last?.dateKey === dateKey) {
            last.items.push(item);
            continue;
        }

        groups.push({
            dateKey,
            date: startOfDay(item.sentAt),
            items: [item],
        });
    }

    return groups;
}
